export const MIN_LABELS_ZOOM = 8;

export class MapLabelFactory {
  public createLabel(
    marker: google.maps.Marker,
    label: string,
    layerUId: string,
    documentUId: string,
    offset?: { left?: number; top?: number },
    divClassName?: string,
    zIndex?: number,
    borderColor?: string,
    backColor?: string
  ): any {
    return new this.LabelOverlay(marker, label, layerUId, documentUId, offset, divClassName, zIndex, borderColor, backColor);
  }

  LabelOverlay = class extends google.maps.OverlayView {
    private div: HTMLElement;
    private className: string;
    lastX: number;
    lastY: number;
    width: number;
    height: number;
    visible: boolean;

    constructor(
      private marker: google.maps.Marker,
      private label: string,
      private layerUId: string,
      private documentUId: string,
      private offset?: { left?: number; top?: number },
      private divClassName?: string,
      private zIndex?: number,
      private borderColor?: string,
      private backColor?: string
    ) {
      super();
      this.visible = marker.getVisible();
    }

    getLayerUId(): string {
      return this.layerUId;
    }

    getdocumentUId(): string {
      return this.documentUId;
    }

    private remove(): void {
      if (this.div && this.div.parentNode) {
        this.div.parentNode.removeChild(this.div);
      }
    }

    public onAdd() {
      if (!this.div) {
        this.div = document.createElement('div');
        if (!!this.divClassName) {
          this.div.className = this.divClassName;
        }
        if (!!this.borderColor) {
          this.div.style.borderColor = this.borderColor;
        }
        if (!!this.backColor) {
          this.div.style.backgroundColor = this.backColor;
        }

        if (this.zIndex !== undefined) {
          this.div.style.zIndex = this.zIndex.toString();
        }

        const label = document.createElement('div');
        label.innerHTML = this.label;

        this.div.style.visibility = this.visible ? 'visible' : 'hidden';

        this.div.appendChild(label);
      }
    }

    public setLabel(label: string) {
      this.label = label;

      if (!this.div) {
        return;
      }

      if (this.div.children.length) {
        this.div.children[0].innerHTML = this.label;
      }
    }

    public getLabel(): string {
      return this.label;
    }

    public onRemove() {
      this.remove();
    }

    private drawLabel(): void {
      const position = this.marker.getPosition();

      const point = this.getProjection().fromLatLngToDivPixel(position);

      this.width = this.div.offsetWidth;

      if (this.div?.offsetWidth > 0) {
        this.width = this.div.offsetWidth;
      }

      // estimate the label width when unknown from DOM
      if (this.width === 0 && !!this.label) {
        this.width = this.label.length * 7;
      }

      const left = point.x + (!!this.offset?.left ? this.offset.left : -this.width / 2);
      const top = point.y + (!!this.offset?.top ? this.offset.top : -75);

      this.div.style.left = left.toFixed() + 'px';
      this.div.style.top = top.toFixed() + 'px';

      const panes = this.getPanes();
      if (!panes.floatPane.contains(this.div)) {
        panes.floatPane.appendChild(this.div);
      }
    }

    public draw(): void {
      this.drawLabel();
    }

    getMarker(): google.maps.Marker{
      return this.marker;
    }

    getMarkerMap(): google.maps.Map {
      return this.marker?.getMap() as google.maps.Map;
    }

    getPosition(): google.maps.LatLng | google.maps.LatLngLiteral {
      return this.marker.getPosition();
    }
    getVisible(): boolean {
      if (!this.div) {
        return true;
      }
      return this.div.style.visibility === 'visible';
    }
    getHasDiv(): boolean {
      return !this.div ? false : true;
    }
    setVisible(value: boolean): void {
      this.visible = value;
      if (!this.div) {
        return;
      }
      this.div.style.visibility = value ? 'visible' : 'hidden';
      if (this.div.offsetWidth > 0) {
        this.width = this.div.offsetWidth;
      }
    }

    showLabel(): void {
      const map = this.marker.getMap();
      const isVisible = this.marker.getVisible();

      this.setMap(map);
      this.setVisible(isVisible);
      this.onAdd();
      this.draw();
    }

    hideLabel(): void {
      this.setMap(null);
      this.onRemove();
    }

    setZIndex(value: number): void {
      if (!this.div) {
        return;
      }
      this.zIndex = value;
      this.div.style.zIndex = value ? value.toString() : '';
    }
    getZIndex(): number {
      if (!this.div) {
        return 0;
      }
      return this.div.style.zIndex ? parseInt(this.div.style.zIndex, 10) : null;
    }
    setClass(className: string): void {
      this.className = className;
    }
    removeClass(className: string): void {
      if (className !== this.className) {
        return;
      }
      this.className = '';
    }
  };
}

interface markerLabels {
  [uid: string]: {
    label: any; //LabelOverlay;
  };
}

interface layerLabels {
  [layerUId: string]: {
    minZoomLevel: number;
    markerLabels: markerLabels;
  };
}
